RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const OTHER_THRESHOLD_MULTIPLE = 3;

    const GroupedBar = widgets.Chart.mixin({
        chartType: RivalIQ.graph.GroupedBar,

        mixins: {
            trailingChart: widgets.Chart.TrailingChart
        },

        getChartClassName: function (d, j, i) {

            const me = this;
            return me.mixins.trailingChart.getChartClassName(me, i, j);
        },

        getTooltip: function () {
            const me = this;

            return {
                title: function (data) {
                    return me.model.getDomainName(data[0], {
                        withInterval: true
                    });
                },

                content: function (data, index, group, options) {
                    const metric = me.model;

                    return new App.widgets.MetricSummaryTooltip({
                        model: metric.clone({
                            className: _.get(options, ['classNames', group]),
                            colorIndex: group,
                            value: metric.format(_.last(data)),
                            title: data[1]
                        })
                    }).render().el.outerHTML;
                }
            };
        },

        getChartAttributes: function () {
            const me = this;

            function convertTimeSpanData(metric, values) {
                const name = metric.getName();
                return _.map(values, function (value, j) {
                    return [j, name, value];
                });
            }

            let otherMetric;
            let otherData;
            let otherMax;
            let valueMax = 0;
            let data = _.flatten(_.compact(me.collection.map(function (metric) {
                if (metric.isOther()) {
                    otherMetric = metric;
                    otherData = metric.getTimeSpanData();
                    otherMax = _.max(otherData);
                    return;
                }

                const timeSpanData = metric.getTimeSpanData();
                valueMax = Math.max(valueMax, _.max(timeSpanData));

                return convertTimeSpanData(metric, timeSpanData);
            })));

            // Omit Other if its max value is greater than the threshold value
            // This improves the y scale for other values
            if (otherData && (otherMax < (OTHER_THRESHOLD_MULTIPLE * valueMax))) {
                data = data.concat(convertTimeSpanData(otherMetric, otherData));
            }

            return {
                concept: me.model,
                metrics: me.collection,
                classNames: me.getChartClassName,
                data: data,
                tickValues: me.getTickValues(),
                ticks: me.getProp('ticks'),
                tooltip: (me.getTooltip ? me.getTooltip() : null),
                height: me.getProp('height'),
                groupNames: me.collection.invoke('getTitle', {
                    abbreviate: true
                })
            };
        }
    });

    const GroupedBarWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        icon: 'fa-area-chart',
        view: GroupedBar,
        processProps: function (props) {
            const me = this;

            props = widgets.Chart.buildMetrics(me, props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_GROUPED_BAR_CHART, GroupedBarWidget);
});
